const SealRing = ({ children }) => (
  <svg viewBox="0 0 40 40" className="w-full h-full" aria-hidden="true">
    <circle cx="20" cy="20" r="18.5" fill="#190A0B" stroke="#C9A227" strokeWidth="1.4" />
    <circle cx="20" cy="20" r="15.5" fill="none" stroke="#C9A227" strokeWidth="0.5" opacity="0.7" />
    <g stroke="#C9A227" fill="none" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
      {children}
    </g>
  </svg>
);

export const MayorSeal = () => (
  <SealRing>
    <circle cx="20" cy="14.5" r="3.4" />
    <path d="M20 17.9 V28" />
    <path d="M20 24.5 h3.4 M20 27 h2.6" />
  </SealRing>
);

export const BiotechSeal = () => (
  <SealRing>
    <path d="M17.5 11.5 h5 M18.5 11.5 V17 L14.5 26.5 a2.4 2.4 0 0 0 2.1 3.2 h6.8 a2.4 2.4 0 0 0 2.1-3.2 L21.5 17 V11.5" />
    <circle cx="19" cy="24.5" r="0.9" fill="#C9A227" stroke="none" />
    <circle cx="21.8" cy="26.8" r="0.7" fill="#C9A227" stroke="none" />
  </SealRing>
);

export const InstituteSeal = () => (
  <SealRing>
    <circle cx="20" cy="20" r="2.2" fill="#C9A227" stroke="none" />
    <ellipse cx="20" cy="20" rx="9" ry="3.8" transform="rotate(-24 20 20)" />
    <ellipse cx="20" cy="20" rx="9" ry="3.8" transform="rotate(24 20 20)" />
    <circle cx="27.6" cy="15.2" r="1.1" fill="#C9A227" stroke="none" />
  </SealRing>
);

export const LegalSeal = () => (
  <SealRing>
    <path d="M20 10.5 V28 M14.5 28.5 h11" />
    <path d="M13 14.5 h14" />
    <path d="M13 14.5 L10.5 21.5 a3.2 2.2 0 0 0 5 0 Z" />
    <path d="M27 14.5 L24.5 21.5 a3.2 2.2 0 0 0 5 0 Z" />
  </SealRing>
);

const CrimsonRing = ({ children }) => (
  <svg viewBox="0 0 40 40" className="w-full h-full" aria-hidden="true">
    <circle cx="20" cy="20" r="18.5" fill="#08070B" stroke="#DC2626" strokeWidth="1.4" />
    <circle cx="20" cy="20" r="15.5" fill="none" stroke="#DC2626" strokeWidth="0.5" strokeDasharray="2 3" opacity="0.7" />
    <path d="M6 8 l5 6 -3 5 6 4" stroke="#DC2626" strokeWidth="0.7" fill="none" opacity="0.8" />
    <g stroke="#DC2626" fill="none" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
      {children}
    </g>
  </svg>
);

export const TwistedMayorSeal = () => (
  <CrimsonRing>
    <circle cx="20" cy="14" r="3.4" />
    <path d="M17.4 12.4 l2 2 M22.6 12.4 l-2 2" strokeWidth="0.8" />
    <path d="M20 17.4 L18.6 23 L21.4 26 L20 29" />
    <path d="M20.8 27.5 h3" />
  </CrimsonRing>
);

export const TwistedBiotechSeal = () => (
  <CrimsonRing>
    <path d="M17.5 11.5 h5 M18.5 11.5 V17 L14.5 26.5 a2.4 2.4 0 0 0 2.1 3.2 h6.8 a2.4 2.4 0 0 0 2.1-3.2 L21.5 17 V11.5" />
    <path d="M17 21 l3 2 -2.5 3" strokeWidth="0.8" />
    <path d="M24.5 24 q1.5 2 0 3.4 q-1.5 -1.4 0 -3.4" fill="#DC2626" stroke="none" />
  </CrimsonRing>
);

export const TwistedInstituteSeal = () => (
  <CrimsonRing>
    <circle cx="20" cy="20" r="2.6" />
    <path d="M20 18.4 V21.6" strokeWidth="0.9" />
    <ellipse cx="20" cy="20" rx="9" ry="3.8" transform="rotate(-24 20 20)" strokeDasharray="4 3" />
    <path d="M27 14 l3 -3 M12 27 l-2.5 2.5" strokeWidth="0.9" />
  </CrimsonRing>
);

export const TwistedLegalSeal = () => (
  <CrimsonRing>
    <path d="M20 10.5 V28 M14.5 28.5 h11" />
    <path d="M12 17 L28 12.5" />
    <path d="M12 17 L10 23.5 a3.2 2.2 0 0 0 5 0 Z" />
    <path d="M28 12.5 L26.5 28 a3 2.4 0 0 0 4.5 1 Z" />
  </CrimsonRing>
);
